//Package Imports
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
//Component Imports
import Header from "../../../common/header/header";
import Search from "../../../components/search/search";
// import TradeTable from "../../../components/trade-table/trade-table";
import TradeTable from "../../../components/trade-table-fc/trade-table";
import Pagination from "../../../components/pagination/pagination";
import ToastNotifcation from "../../../components/toast/toast";
//Provider Import
import TradeContext from "../../../store/tradeState/tradeContext";
import AuthContext from "../../../auth/auth-context";
import axios from "axios";

//Style Imports
import "./trades.css";
import TradeButtonContainer from "../../../components/trade-button-container/trade-button-container";
import TradeContainer from "../../../components/trade-table/trade/trade-container";
import NoteModal from "../../../components/notes/notes";
import TradeFilesModal from "../../../components/trade-files/TradeFiles";
import DropdownButton from "../../../components/DropdownButton/DropdownButton";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

const searchOptions = [
  { name: "Trade Number", value: "trade_reference_number" },
  { name: "Account", value: "account_number" },
  { name: "Date", value: "value_date" },
  { name: "Status", value: "status__name" },
  { name: "Type", value: "allowance_type" },
  { name: "Exchange Rate", value: "exchange_rate" },
];

const Trades = () => {
  const trdCtx = useContext(TradeContext);
  const authCtx = useContext(AuthContext);

  const [showCompleteTradeModal, setShowCompletedTradeModal] = useState(false);
  const [tradeCompleteLoading, setTradeCompleteLoading] = useState(false);

  const headers = {
    "Acting-as": "dealer",
    Authorization: `JWT ${authCtx?.token}`,
  };

  const handleChange = (e) => {
    e.target.id === "searchFilter"
      ? trdCtx.setSearchParam(e.target.value)
      : trdCtx.setSearchValue(e.target.value);
  };

  const renderActionButton = () => {
      return (
        <div className="d-flex justify-content-end align-items-center" style={{ gap: '0.5rem' }}>
        {/* {selectedTrades.length > 0 && (
            <span className="fw-semibold text-table">
                (Selected:{' '}
                <span className="text-theme-light-orange">{selectedTrades.length}</span>)
            </span>
        )} */}
        <DropdownButton title="Actions" disabled={trdCtx.tradeBatch.length === 0 || !checkTradeStatuses()}>
            <div className="py-1" style={{ width: '125px' }}>
                {renderTradeActions()}
            </div>
        </DropdownButton>
    </div>
      );
  };

  const checkTradeStatuses = () => {
    const selectedTradesArray = [];
  
    // find all selected services in the client data that are also in the selectedQuotes array
    trdCtx.trades.filter((trade) => {
        if (trdCtx.tradeBatch.includes(trade.id)) {
          selectedTradesArray.push({
                id: trade.id,
                status: trade.trade_status,
            });
        }
    });

    const allBooked = selectedTradesArray.every(
        (trade) => trade.status === 1,
    );
    return allBooked;
  }
  
  const renderTradeActions = () => {
    const actionElements = [];
    const selectedTradesArray = [];
  
    // find all selected services in the client data that are also in the selectedQuotes array
    trdCtx.trades.filter((trade) => {
        if (trdCtx.tradeBatch.includes(trade.id)) {
          selectedTradesArray.push({
                id: trade.id,
                status: trade.trade_status
            });
        }
    });
  
    const allBooked = selectedTradesArray.every(
        (trade) => trade.status === 1,
    );


    {
      allBooked &&
            actionElements.push(
              <button
              className="dropdown-item text-gray-800 w-100"
              onClick={() => setShowCompletedTradeModal(true)}
          >
              Complete Trades
          </button>,
            );
    }
    return actionElements;
  };

  const handleCompleteBatchTrades = async () => {
    try {
      setTradeCompleteLoading(true);

      const body = { trade_ids: trdCtx.tradeBatch };

      const completeBulkTradeRes = await axios.post(`${process.env.REACT_APP_SERVER_URL}/trades/set_bulk_completed/`, body, { headers: headers })


      if(completeBulkTradeRes.data.result === 'success' && completeBulkTradeRes.data.updated_ids){
        // tradeCtx.trades = tradeCtx.trades.find((trade) => trade.id === props.tradeId).trade_status = 2;
        trdCtx.setTradeBatch([]);
        trdCtx.setShowToast(true);
        trdCtx.setToastResult('success');
        trdCtx.setToastMessage('Trade(s) completed successfully');
        trdCtx.setAllBookedTradesChecked(false);
        trdCtx.getTrades();
        setShowCompletedTradeModal(false);
        
      }

    } catch(err){
      console.log('Error completing trade', err);
      setTradeCompleteLoading(false);
    }
  }

  return (
    <div className="flex flexCol w-full">
      <Header title="Trades" />
      <ToastNotifcation
        showToast={trdCtx.showToast}
        closeToast={() => trdCtx.setShowToast(false)}
        toastResult={trdCtx.toastResult}
        toastMessage={trdCtx.toastMessage}
      />
      <div className="flex flex-row justify-between items-center w-full px-4 py-2">
        <Search
          options={searchOptions}
          handleChange={handleChange}
          searchCallback={() => console.log("use effect will search")}
          resetPage={() => trdCtx.setPage(1)}
          searchFilter={trdCtx.searchParam}
          searchText={trdCtx.searchValue}
        />
        <div className="w-full flex justify-end">{renderActionButton()}</div>
      </div>
      {/* <TradeButtonContainer /> */}
      <TradeTable />
      <div className="row mt-2 table-footer">
        {/* <div className="col-8 card flex-row">
          <span>Hot Keys:</span>
          <span>Shift + N (New Trade)</span>
          <span>Shift + B (Retry Batch)</span>
        </div> */}
        <div className="col-4 card bg-w">
          <Pagination
            handleChange={(e) => trdCtx.setRowsPerPage(e.target.value)}
            search={() => {}}
            rows_per_page={trdCtx.rowsPerPage}
            resetPage={() => trdCtx.setPage(1)}
            page={trdCtx.page}
            page_count={trdCtx.pageCount}
            //upper_threshold={this.state.upper_threshold}
            //lower_threshold={this.state.lower_threshold}
            pageUp={() =>
              trdCtx.setPage(
                trdCtx.page != trdCtx.pageCount ? trdCtx.page + 1 : trdCtx.page
              )
            }
            pageDown={() =>
              trdCtx.setPage(trdCtx.page != 1 ? trdCtx.page - 1 : trdCtx.page)
            }
          />
        </div>
      </div>
      {trdCtx.showNotes && (
        <NoteModal
          showNotes={trdCtx.showNotes}
          showModal={() => {
            trdCtx.setShowNotes(!trdCtx.showNotes);
          }}
          id={trdCtx.trade.id}
          trade_id={trdCtx.trade.id}
          client_id={trdCtx.trade.customer.id}
          client={trdCtx.trade.customer.name}
          tradeSearch={() => trdCtx.getTrades()}
          searchField="trade"
        />
      )}
      {trdCtx.showFiles && (
        <TradeFilesModal
          showFiles={trdCtx.showFiles}
          showModal={() => {
            trdCtx.setShowFiles(!trdCtx.showFiles);
          }}
          id={trdCtx.trade.id}
          trade_id={trdCtx.trade.id}
          client_id={trdCtx.trade.customer.id}
          client={trdCtx.trade.customer.name}
          tradeSearch={() => trdCtx.getTrades()}
          searchField="trade"
        />
      )}
      {trdCtx.showTrade && (
        <TradeContainer
          currentTrade={trdCtx.trade}
          showForm={trdCtx.showTrade}
          callbackShowForm={() => trdCtx.setShowTrade(true)}
          closeForm={() => trdCtx.setShowTrade(false)}
          callbackExecute={() => console.log("Execute Trade")}
          callbackCancel={() => console.log("Cancel Trade")}
          callbackAdd={() => console.log("Add Trade")}
          callbackRetry={() => {
            trdCtx.setShowTrade(false);
            trdCtx.retryTrades([trdCtx.trade.id]);
          }}
          config={true}
        />
      )}
      {showCompleteTradeModal && (
        <Modal
          animation={false}
          show={showCompleteTradeModal}
          onHide={() => setShowCompletedTradeModal(false)}
          size="lg"
        >
          <Modal.Header>
            <span>Trade Action</span>
          </Modal.Header>
          <Modal.Body>
          <div>Are you sure you want to completed the selected trades?</div>
            <div className="d-flex gap-2 pt-4">
              
              <Button
                onClick={() => setShowCompletedTradeModal(false)}
                className="btn btn-danger"
              >
                Cancel
              </Button>
              <Button
                onClick={handleCompleteBatchTrades}
                className="btn btn-success"
                disabled={tradeCompleteLoading}
              >
                {tradeCompleteLoading ? 'Loading...' : 'Complete'}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

Trades.propTypes = {
  trades: PropTypes.array,
  add: PropTypes.func,
  updateStatus: PropTypes.func,
  executeTrade: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  newTrades: PropTypes.bool,
  tradeSearch: PropTypes.func,
};

export default Trades;
